import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputSelectComponent } from 'src/app/shared/components/inputs/input-select/input-select.component';
import { AreraAtoService } from '../../arera-ato.service';
import { AreraAtoSearchTemplateComponent } from '../arera-ato-search-template/arera-ato-search-template.component';

@Component({
  selector: 'app-arera-ato-input-select',
  standalone: true,
  imports: [
    CommonModule,
    InputSelectComponent,
    AreraAtoSearchTemplateComponent
  ],
  templateUrl: './arera-ato-input-select.component.html',
  styleUrl: './arera-ato-input-select.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreraAtoInputSelectComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() name: string = '';

  areraAto = this.areraAtoService.query.list;
  searchTemplate = AreraAtoSearchTemplateComponent;

  constructor(
    @Inject(AreraAtoService) public areraAtoService: AreraAtoService,
  ) { }

  ngOnInit(): void {
      this.getareraAto();
  }

  getareraAto() {
    this.areraAtoService.query.getAll();
  }
}
